"use client"

import { Progress as ProgressPrimitive } from "radix-ui"
import * as React from "react"

import { cn } from "@/common/lib/utils"

function Progress({
    className,
    value,
    color,
    ...props
}: React.ComponentProps<typeof ProgressPrimitive.Root> & { color?: string }) {
    // Determine color based on value
    const getIndicatorColor = (val: number | null | undefined) => {
        if (!val || val === null) return "bg-destructive"
        if (val > 85) return color === "success" ? "bg-success" : "bg-warning"
        if (val >= 35) return color === "success" ? "bg-success" : "bg-warning"
        return color === "success" ? "bg-success" : "bg-warning"
    }
    return (
        <ProgressPrimitive.Root
            data-slot="progress"
            className={cn("bg-primary/20 relative h-2 w-full overflow-hidden rounded-full", className)}
            {...props}
        >
            <ProgressPrimitive.Indicator
                className={cn("h-full w-full flex-1 transition-all", getIndicatorColor(value))}
                style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
            />
        </ProgressPrimitive.Root>
    )
}

export { Progress }
